// hooks/useLocale.ts
'use client';

import { useParams } from 'next/navigation';
import type { Locale } from '@/i18n/config';

/**
 * Custom hook to replace next-intl's useLocale
 * Returns the current locale from the URL parameters
 */
export function useLocale(): Locale {
  const params = useParams();
  return params?.locale as Locale;
}

// Alternative version with fallback to default locale
export function useLocaleWithFallback(): Locale {
  const params = useParams();
  const locale = params?.locale as Locale;

  // Import your default locale from i18n-config if needed
  // You can also hardcode it or pass it as a parameter
  const defaultLocale = 'en' as Locale; // Replace with your actual default

  return locale || defaultLocale;
}

// Enhanced version with additional locale utilities
export function useLocaleInfo() {
  const params = useParams();
  const locale = params?.locale as Locale;

  return {
    locale,
    isDefaultLocale: locale === 'en', // Replace "en" with your default locale
    // Add more utilities as needed
    formatters: {
      // You can add Intl formatters here if needed
      currency: new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'USD',
      }),
      date: new Intl.DateTimeFormat(locale),
      number: new Intl.NumberFormat(locale),
    },
  };
}
